import { render, staticRenderFns } from "./MenuBox.vue?vue&type=template&id=719a9b3e&"
import script from "./MenuBox.vue?vue&type=script&lang=js&"
export * from "./MenuBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MenuBox.vue"
export default component.exports